import styles from './project-detail.module.scss';
import { useDraggable } from '@/lib/hooks/useDraggable';

interface Props {
  title: string;
  client: string;
  services: string[];
  description: string;
  initialPosition: { x: number; y: number };
  size: { width: number; height: number };
  constrainingFunction?: (pos: { x: number; y: number }, size: { width: number; height: number }) => { x: number; y: number };
  animationDelay?: number;
  zIndex: number;
  onPointerDownCapture?: () => void;
  widthContent: number;
  isCollapsing?: boolean;
}

export default function ProjectInfo({ title, client, services, description, initialPosition, size, constrainingFunction, animationDelay, zIndex, onPointerDownCapture, widthContent, isCollapsing = false }: Props) {
  const { position, isPointerDown, isDraggingRef, onPointerDown } = useDraggable({
    initialPosition,
    allowDragging: true,
    constrainingFunction,
    size,
    isOnLandingPage: false
  });

  const handlePointerDownOnElement = (event: React.PointerEvent<HTMLDivElement>) => {
    onPointerDownCapture?.();
    onPointerDown(event);
  };

  const handleClick = (event: React.MouseEvent) => {
    // Stop click events from propagating to parent elements (e.g., ProjectDetail's returnToLandingPage)
    event.stopPropagation();
  };

  const titleFontSize = Math.ceil(widthContent / 160);
  const bodyCopyFontSize = Math.ceil(widthContent / 180);

  return (
    <div
      className={`${styles['project-info']} ${isCollapsing ? styles['collapseWindow'] : styles['expandWindow']}`}
      style={{ 
        left: position.x, 
        top: position.y, 
        cursor: isPointerDown ? "grabbing" : "grab", 
        width: size.width, 
        animationDelay: `${animationDelay}s`,
        zIndex: zIndex,
        fontSize: bodyCopyFontSize
      }}
      onPointerDown={handlePointerDownOnElement}
      onClick={handleClick}
    >
      <h1 className={styles.title} style={{fontSize: titleFontSize}}>{title}</h1>
      <div className={styles['project-info-content']}>
        {/* Client, Services, Project Title */}
        <div className={styles['top-section']}>
          <div className={styles['first-column']}>
            <div>
              <p className={styles.category}>\\CLIENT</p>
              <p>{client}</p>
            </div>
            <div>
              <p className={styles.category}>\\Experiment</p>
              <p>{title}</p>
            </div>
          </div>
          <div className={styles['second-column']}>
            <p className={styles.category}>\\SERVICES</p>
            {services.map((service, index) => (
              <p key={index}>{service}</p>
            ))}
          </div>
        </div>
        {/* Project Description */}
        <div>
          <p className={styles.category}>\\LAB_REPORT</p>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}